import { Grid, IconButton, makeStyles, Paper, Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel, Tooltip } from "@material-ui/core";
import React, { useState } from "react";
import { SoftwareReleaseEyeIcon, SortIcon } from "../../LeftNav/SvgIcons";
import moment from "moment";
import CSVFile from "../../../../components/common/ExportCSVFile/CSVFile";
import { ActivityLogDetailsView } from "./ActivityLogsDetailModal";
import { TooltipDescription } from "../../../../components/common/Modal/AssetsModals";
import TagsOverlay from "../ConversationsRevamp/TagsOverlay";
import { OpenInNew } from "@material-ui/icons";

const useStyles = makeStyles(theme => ({
    gridHeaderInner: {
        color: "#A9B2BC",
        fontSize: "12px",
        fontWeight: "700",
        paddingTop: "16px",
        paddingBottom: "16px",
    },

    gridBodyInner: {
        color: "#464E5F",
        fontSize: "14px",
        fontWeight: "400",
        paddingTop: "16px",
        paddingBottom: "16px",
    },

    gridHeader: {
        background: "#E5F2FF",
        borderRadius: "6px",
    },
    gridHeaderRow: {
        borderRadius: "6px",
    },
    gridIconCells: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "15px",
        "& span": {
            cursor: "pointer",
        },
    },
    csvFile: {
        gap: "10px",
        padding: "10px 0",
        display: "flex",
        justifyContent: "flex-start",
    },
    actionButtons: {
        padding: "unset",
        "&:hover": {
            backgroundColor: "transparent",
            boxShadow: "none",
        },
    },
    gridBodyInnerAction: {
        color: "#A9B2BC",
        fontSize: "12px",
        fontWeight: "700",
        paddingTop: "16px",
        paddingBottom: "16px",
        alignItems: "center",
        justifyContent: "end",
        marginRight: "30px",
        cursor: "pointer",
    },
    gridBodyInnerPlatefrom: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    gridHeaderInnerPlatform: {
        textAlign: "center !important"
    },
    gridBodyInnerMessage: {
        width: "max-content",
        display: "flex",
    },
    deleteItems: {
        marginBottom: "10px",
    }
}));

const ActivityLogsList = ({
    logsData,
    order,
    onOrderBy,
    page,
    handleExport,
    selectedUserId,
}) => {
    const classes = useStyles();
    const [modalContent, setModalContent] = useState(null);

    const isValidObject = (payload, isColor = true) => {
        try {
            const parsedPayload = JSON.parse(payload);
            return parsedPayload && typeof parsedPayload === 'object' && Object.keys(parsedPayload).length > 0;
          } catch (error) {
            if (typeof payload === "string" && isColor) return true;
            return false;
          }
    };

    return (
        <Paper>
            <Paper>
                {logsData?.length > 0 && (<Grid item md={12} className={classes.csvFile}>
                    <CSVFile
                        handleExport={handleExport}
                    />
                </Grid>)}
            </Paper>
            <Table>
                <TableHead className={classes.gridHeader}>
                    <TableRow className={classes.gridHeaderRow}>
                        {/* <TableCell className={classes.gridHeaderInner}>
                            Username
                            <TableSortLabel
                                active={order.orderByKey === "UserName"}
                                direction={order.orderVal === 1 ? "asc" : "desc"}
                                onClick={() =>
                                    onOrderBy({
                                        orderByKey: "UserName",
                                        orderVal: order.orderVal === 0 ? 1 : 0,
                                    })
                                }
                                IconComponent={SortIcon}
                                className='sortIcon'
                            />
                        </TableCell> */}
                        <TableCell className={classes.gridHeaderInner}>
                            IP Address
                            <TableSortLabel
                                active={order.orderByKey === "IpAddress"}
                                direction={order.orderVal === 1 ? "asc" : "desc"}
                                onClick={() =>
                                    onOrderBy({
                                        orderByKey: "IpAddress",
                                        orderVal: order.orderVal === 0 ? 1 : 0,
                                    })
                                }
                                IconComponent={SortIcon}
                                className='sortIcon'
                            />
                        </TableCell>
                        <TableCell className={classes.gridHeaderInner}>
                            Platform
                            <TableSortLabel
                                active={order.orderByKey === "Platform"}
                                direction={order.orderVal === 1 ? "asc" : "desc"}
                                onClick={() =>
                                    onOrderBy({
                                        orderByKey: "Platform",
                                        orderVal: order.orderVal === 0 ? 1 : 0,
                                    })
                                }
                                IconComponent={SortIcon}
                                className='sortIcon'
                            />
                        </TableCell>
                        <TableCell className={classes.gridHeaderInner}>
                            Controller Name
                            <TableSortLabel
                                active={order.orderByKey === "ActionMethodName"}
                                direction={order.orderVal === 1 ? "asc" : "desc"}
                                onClick={() =>
                                    onOrderBy({
                                        orderByKey: "ActionMethodName",
                                        orderVal: order.orderVal === 0 ? 1 : 0,
                                    })
                                }
                                IconComponent={SortIcon}
                                className='sortIcon'
                            />
                        </TableCell>
                        <TableCell className={classes.gridHeaderInner}>
                            Action Name
                            <TableSortLabel
                                active={order.orderByKey === "ControllerName"}
                                direction={order.orderVal === 1 ? "asc" : "desc"}
                                onClick={() =>
                                    onOrderBy({
                                        orderByKey: "ControllerName",
                                        orderVal: order.orderVal === 0 ? 1 : 0,
                                    })
                                }
                                IconComponent={SortIcon}
                                className='sortIcon'
                            />
                        </TableCell>
                        <TableCell className={classes.gridHeaderInner}>
                            Message
                            <TableSortLabel
                                active={order.orderByKey === "Message"}
                                direction={order.orderVal === 1 ? "asc" : "desc"}
                                onClick={() =>
                                    onOrderBy({
                                        orderByKey: "Message",
                                        orderVal: order.orderVal === 0 ? 1 : 0,
                                    })
                                }
                                IconComponent={SortIcon}
                                className='sortIcon'
                            />
                        </TableCell>
                        <TableCell className={classes.gridHeaderInner}>
                            Request Time
                            <TableSortLabel
                                active={order.orderByKey === "RequestTime"}
                                direction={order.orderVal === 1 ? "asc" : "desc"}
                                onClick={() =>
                                    onOrderBy({
                                        orderByKey: "RequestTime",
                                        orderVal: order.orderVal === 0 ? 1 : 0,
                                    })
                                }
                                IconComponent={SortIcon}
                                className='sortIcon'
                            />
                        </TableCell>

                        <TableCell
                            className={
                                (classes.gridHeaderInnerPlatform)
                            }>
                            Details
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {logsData?.map(item => {
                        return (
                            <TableRow
                                key={item.id}
                                className={`gridBodyRow endUserRow`}>
                                {/* <TableCell
                                    className={(classes.gridBodyInner, "capitalize-first")}>
                                    {item.userName}
                                </TableCell> */}
                                <TableCell
                                    className={
                                        (classes.gridBodyInner,
                                            "tableItemHighlight",
                                            "capitalize-first")
                                    }>
                                    {item?.ipAddress || "--"}
                                </TableCell>
                                <TableCell
                                    className={(classes.gridBodyInner, "lastLoginWrapper")}>
                                    {item.platform}
                                </TableCell>
                                <TableCell className={(classes.gridBodyInner)}>
                                    {item.controllerName}
                                </TableCell>
                                <TableCell className={(classes.gridBodyInner)}>
                                    {item.actionMethodName}
                                </TableCell>
                                <TableCell className={(classes.gridBodyInner)}>
                                    <TooltipDescription
                                        title={<TagsOverlay
                                            title="Message"
                                            noChipText="No Message Found"
                                            tags={[]}
                                            text={item.message ?? ""}
                                            />}
                                        placement={"bottom"}>
                                        <span className={classes.gridBodyInnerMessage}>
                                            {item.message ? item.message.length <= 30 ? item.message : `${item.message.substring(0, 29)}...` : "--"}
                                        </span>
                                    </TooltipDescription>
                                </TableCell>

                                <TableCell
                                    className={classes.gridBodyInner}>
                                    {item.requestTime !== null && item.requestTime !== ""
                                        ? moment(item.requestTime).format("MMMM DD, YYYY")
                                        : "--"}
                                </TableCell>
                                <TableCell
                                    className={(classes.gridBodyInnerAction, "lastLoginWrapper")}>
                                    <Tooltip title={"Request"} placement="top">
                                        <IconButton
                                            disabled={!item.request}
                                            onClick={() => {
                                                setModalContent({ title: 'Request Details', value: JSON.parse(item.request) });
                                            }}
                                        ><SoftwareReleaseEyeIcon
                                                style={{
                                                    fill: item?.request
                                                        ? "#BADAFB"
                                                        : "rgba(0, 0, 0, 0.08)",
                                                    fill2: item?.request
                                                        ? "#4EA5FE"
                                                        : "rgba(0, 0, 0, 0.24)",
                                                }} /></IconButton>
                                    </Tooltip>
                                    <Tooltip title={"Payload"} placement="top">
                                        <IconButton
                                            disabled={!item.payload}
                                            onClick={() => {
                                                setModalContent({ title: 'Payload Details', value: isValidObject(item.payload, false) ? JSON.parse(item.payload) : { payload: item.payload } });
                                            }}
                                        ><OpenInNew
                                                style={{
                                                    fill: (item.payload?.length > 0 && isValidObject(item.payload))
                                                        ? "rgb(54, 153, 255)"
                                                        : "rgba(0, 0, 0, 0.08)"
                                                }} /></IconButton>
                                    </Tooltip>
                                </TableCell>
                            </TableRow>
                        );
                    })}
                    {(!selectedUserId && logsData.length === 0) && (
                        <TableRow key='0' className='gridBodyRow'>
                            <TableCell
                                colSpan='7'
                                className={classes.gridBodyInner}
                                style={{ textAlign: "center" }}>
                                <span className='emptyGridText'>
                                    Please select a user and dates to get logs!
                                </span>
                            </TableCell>
                        </TableRow>
                    )}
                    {(selectedUserId && logsData.length <= 0) && (
                        <TableRow key='0' className='gridBodyRow'>
                            <TableCell
                                colSpan='7'
                                className={classes.gridBodyInner}
                                style={{ textAlign: "center" }}>
                                <span className='emptyGridText'>
                                    Uh Oh! No logs found for selected user!
                                </span>
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
            <ActivityLogDetailsView
                openPopup={modalContent}
                setOpenPopup={setModalContent} />
        </Paper>
    );
};

export { ActivityLogsList };
